<template>
  <div class="house-importer-import-finished-stage" >
    <portal to="houseImporterHeaderCenter">
      <div class="house-import-stage-status">
        <div class="house-import-stage-status">
          {{importInfo.status}}
        </div>
        <router-link tag="span" :to="{name: 'houseImporter_main'}" class="link-icon">Вернуться на главную</router-link>
      </div>
    </portal>

    <div class="house-importer-import-finished-stage__row">
      <div class="house-importer-import-finished-stage__col house-importer-import-finished-stage__col-1/3">
        <div class="house-importer-import-finished-stage__col-content">
          <CheckListPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <PaymentInfoPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <ImportPaymentsPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <ImportDevicesValuesPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <RestoreTariffs :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <RestoreChargesFromFile :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <RestoreHeaterValuesPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <ShowInvoicesPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <AddOldAccountsPanel :importInfo="importInfo"/>
        </div>
      </div>
      <div class="house-importer-import-finished-stage__col house-importer-import-finished-stage__col-2/3">
        <div class="house-importer-import-finished-stage__col-content">
          <KvTextsPanel :importInfo="importInfo"/>
        </div>
        <div class="house-importer-import-finished-stage__col-content">
          <CheckChargesPanel :importInfo="importInfo"/>
        </div>
<!--        <div class="house-importer-import-finished-stage__col-content">-->
<!--          <ImportDevicesPanel :importInfo="importInfo"/>-->
<!--        </div>-->
        <div class="house-importer-import-finished-stage__col-content">
          <EditDevices :importInfo="importInfo" showUpdateStatusButton/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CheckListPanel from "./panels/CheckListPanel";
  import PaymentInfoPanel from "./panels/PaymentInfoPanel";
  import KvTextsPanel from "./panels/KvTextsPanel";
  import ImportPaymentsPanel from "./panels/ImportPaymentsPanel";
  import AddOldAccountsPanel from "./panels/AddOldAccountsPanel";
  import CheckChargesPanel from "./panels/CheckChargesPanel";
  import ImportDevicesValuesPanel from "./panels/ImportDevicesValuesPanel";
  import EditDevices from "../import-charges-stage/panels/EditDevices";
  import RestoreTariffs from "./panels/RestoreTariffs";
  import RestoreHeaterValuesPanel from "./panels/RestoreHeaterValuesPanel";
  import ImportDevicesPanel from "./panels/ImportDevicesPanel";
  import ShowInvoicesPanel from "./panels/ShowInvoicesPanel";
  import RestoreChargesFromFile from "@/components/house-importer/import-finished-stage/panels/RestoreChargesFromFile";



  export default {
    name: "ImportFinishedStage",
    components: {
      CheckListPanel,
      PaymentInfoPanel,
      KvTextsPanel,
      ImportPaymentsPanel,
      AddOldAccountsPanel,
      CheckChargesPanel,
      ImportDevicesValuesPanel,
      EditDevices,
      RestoreTariffs,
      RestoreHeaterValuesPanel,
      ImportDevicesPanel,
      ShowInvoicesPanel,
      RestoreChargesFromFile
    },
    props: {
      importInfo: {}
    }
  }
</script>

<style lang="scss">
  .house-importer-import-finished-stage{
    padding-bottom: 50px;

    &__row{
      margin: 0 -7.5px;
      display: flex;
    }

    &__col{
      padding: 0 7.5px;
      flex: 1;

      &-content{
        margin-bottom: 15px;
      }

      &-1\/3{
        flex-basis: 33.3333%;
        max-width: 33.3333%;
      }

      &-2\/3{
        flex-basis: 66.6667%;
        max-width: 66.6667%;
      }
    }

  }
</style>
